import {
  Breadcrumb,
  Button,
  PageHeader,
  Table,
  Popconfirm,
  message,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { materialTypeService } from "_services";
import TabMenu from "../TabMenu";
import { Auth } from "_helpers";

function List({ match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [stockType, setStockType] = useState({});
  const [suppliers, setSuppliers] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);

    materialTypeService
      .getById(id)
      .then((x) => {
        let data = x.content;
        setIsLoading(false);
        setStockType(x.content);
        setSuppliers(x.content.supplierCompanies);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  }, []);

  const handleDelete = (id) => {
    /* binService
        .removeParent(id, subBinId)
        .then((data) => {
          message.success("Successfully deleted!");
          //setItems(data.content);
          document.location.reload();
        })
        .catch((error) => {
          setError(error);
        }); */
  };

  const getAdditionalButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Link to={`${path}/add`.replace(":id", id)} key="1">
          <Button>Add</Button>
        </Link>
      );
    }
    return buttons;
  };

  const columns = [
    {
      title: "Company",
      dataIndex: ["company", "name"],
      key: "companyName",
      render: (text, record) => {
        return record.company.name;
      }
    },
    {
      title: "Purchase Price",
      dataIndex: "purchasePrice",
      key: "purchasePrice",
    },
    {
      title: "Currency",
      dataIndex: ["currency","name"],
      key: "currancyName",
      render: (text, record) => {
        return record.currency?.name;
      }
    },
    {
      title: "Min. Order Qty",
      dataIndex: "minimumOrderQuantity",
      key: "minimumOrderQuantity",
    },
    {
      title: "Last Purchase Date",
      dataIndex: "lastPurchaseDate",
      key: "lastPurchaseDate",
    },
    {
      title: "Last Purchase Price",
      dataIndex: "lastPurchasePrice",
      key: "lastPurchasePrice",
    },
    {
      title: "Preferred Supplier",
      dataIndex: ["supplierCompanies", "preferredSupplier"],
      key: "preferredSupplier",
      render: (text, record) => {
        return record.preferredSupplier ? "YES" : "NO";
      }
    },
    {
      title: "Contract Start Date",
      dataIndex: "contractStartDate",
      key: "contractStartDate",
    },
    {
      title: "Contract End Date",
      dataIndex: "contractEndDate",
      key: "contractEndDate",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <Popconfirm
            title="Are you sure to delete this item?"
            onConfirm={() => handleDelete(record.id)}
            disabled={!Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])}
          >
            <CloseOutlined />
          </Popconfirm>
        );
      },
    },
  ];

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item href="/dashboard">
              <span>Dashboard</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/material-types">
              <span>Material Search</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href={`/material-types/${stockType.id}/summary`}>
              <span>Material: {stockType.code}</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Suppliers</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getAdditionalButtons()}
      >
        <Page inner error={error}>
          <TabMenu menu="suppliers" id={id} />
          <Table
            bordered
            loading={isLoading}
            rowKey="id"
            size="small"
            columns={columns}
            dataSource={suppliers}
            pagination={false}
          />
        </Page>
      </PageHeader>
    </div>
  );
}

export default List;
